(function (scope) {
  'use strict';
  const FIELDS = [
    { key: 'bust', label: 'BUST', property: 'BUST', min: 27, max: 67, tip: 'Wear the bra you will be wearing with the dress, and pull the tape across the fullest part of the bust.', image: 'pc4_430x.jpg?v=1705393664', video: '7d2be4aed2c340c7b901c079b6077c4f/7d2be4aed2c340c7b901c079b6077c4f.SD-480p-1.5Mbps-23262110.mp4' },
    { key: 'waist', label: 'WAIST', property: 'WAIST', min: 22, max: 70, tip: 'Pull tape across the narrowest part and keep tape slightly loose to allow for breathing room.', image: 'pc3_430x.jpg?v=1705393664', video: '56d576f5a7c44462a21383f0be872724/56d576f5a7c44462a21383f0be872724.SD-480p-1.5Mbps-23263638.mp4' },
    { key: 'hips', label: 'HIPS', property: 'HIPS', min: 30, max: 74.5, tip: 'Stand straight and pull tape across the widest part of the hips and rear.', image: 'pc2_430x.jpg?v=1705393664', video: '1967de2c2f5c45acac3b2692296ecc62/1967de2c2f5c45acac3b2692296ecc62.SD-480p-1.5Mbps-23263765.mp4' },
    { key: 'butt', label: 'BUTT', property: 'BUTT', min: 22, max: 77, optional: true, tip: 'This measurement is necessary if your butt is bigger than your hips.', image: 'butt.jpg' },
    { key: 'hollow', label: 'HOLLOW TO HEM', property: 'HOLLOW TO HEM', min: 31, max: 90, tip: 'Stand straight with bare feet together and measure from the center of the collarbone to the floor.', image: 'pc1_430x.jpg?v=1705393663', video: 'a0035484c780464787dbc468f0c16fc9/a0035484c780464787dbc468f0c16fc9.HD-720p-4.5Mbps-23263682.mp4' },
    { key: 'height', label: 'HEIGHT (BAREFOOT)', property: 'HEIGHT', min: 54, max: 100, tip: 'Stand straight with bare feet together and measure from the top of the head to the floor.' },
    { key: 'belly', label: 'BELLY', property: 'BELLY', min: 23, max: 71, optional: true, tip: 'If you have a big belly, please give us its measurement in the order note too.', image: 'WechatIMG318.png?v=1718075754' }
  ];
  const MEASUREMENT_KEYS = new Set(['SIZE', 'UNIT', 'BUST', 'WAIST', 'HIPS', 'BUTT', 'HOLLOW TO HEM', 'HOLLOW TO FLOOR', 'HEIGHT', 'HEIGHT (BAREFOOT)', 'BELLY', 'HEIGHT OF HEELS']);
  const HEELS = ['Please select', '+0', '+1inch/2.5cm', '+2inch/5.0cm', '+3inch/7.6cm', '+4inch/10cm', '+5inch/12.7cm'];
  const FILES = 'https://cdn.shopify.com/s/files/1/0263/1427/6912/files/';
  const VIDEOS = 'https://cdn.shopify.com/videos/c/vp/';
  function clean(value) { return String(value == null ? '' : value).trim(); }
  function normalizeUnit(value) { return /^(cm|centimeters?)$/i.test(clean(value)) ? 'CM' : 'IN'; }
  // Keep the user's last typed value, not the rounded conversion, as the source.
  // The caller can retain this small state across a dialog rerender.
  function convertMeasurements(values, from, to, state) {
    const result = Object.assign({}, values || {});
    const current = normalizeUnit(from);
    const next = normalizeUnit(to);
    const memory = state || {};
    const fields = memory.fields || (memory.fields = {});
    FIELDS.forEach(function (field) {
      if (!Object.prototype.hasOwnProperty.call(result, field.key)) return;
      const value = clean(result[field.key]);
      if (!value || !Number.isFinite(Number(value))) { delete fields[field.key]; return; }
      let source = fields[field.key];
      if (!source || source.displayUnit !== current || source.displayValue !== value) {
        source = fields[field.key] = { value, unit: current };
      }
      const converted = source.unit === next ? source.value : String(Math.round((Number(source.value) * (next === 'CM' ? 2.54 : 1 / 2.54) + Number.EPSILON) * 100) / 100);
      // Clicking the already active unit must not normalize or multiply again.
      result[field.key] = current === next ? result[field.key] : converted;
      source.displayValue = clean(result[field.key]);
      source.displayUnit = next;
    });
    return result;
  }
  const LEGACY_FIELDS = {
    bust: '.ced-input-bust,.ced-input-bust11,.ced-input-bust1',
    waist: '.ced-input-waist,.ced-input-waist11,.ced-input-waist1',
    hips: '.ced-input-hips,.ced-input-hips11,.ced-input-hips1',
    butt: '.ced-input-butt,.ced-input-butt11,.ced-input-butt1',
    hollow: '.ced-input-hollow,.ced-input-hollow11,.ced-input-hollow1',
    height: '.ced-input-height,.ced-input-height11,.ced-input-height1',
    belly: '.ced-input-optional,.ced-input-optional1'
  };
  function bindLegacyForms(doc) {
    if (!doc || doc.__csCustomUnitBridge) return;
    doc.__csCustomUnitBridge = true;
    function ownerFor(form) { return form.closest('.shopify-product-form') || form.closest('.popup-content') || form; }
    function formsFor(owner) { return owner.classList && owner.classList.contains && owner.classList.contains('ced-custom-form') ? [owner] : Array.from(owner.querySelectorAll('.ced-custom-form')); }
    function stateFor(owner, form) {
      if (!owner.__csCustomUnitState) owner.__csCustomUnitState = { unit: normalizeUnit((form.querySelector('.input-unit') || {}).value) };
      return owner.__csCustomUnitState;
    }
    function setUnit(form, unit) {
      form.querySelectorAll('.input-unit').forEach(function (input) {
        input.value = unit === 'CM' ? 'Centimeter' : 'Inch';
        input.setAttribute('value', input.value);
      });
      form.querySelectorAll('.unit').forEach(function (label) { label.textContent = unit === 'CM' ? '(CM)' : '(Inch)'; });
      form.querySelectorAll('.unit-switch').forEach(function (button) { button.classList.toggle('right', unit === 'CM'); });
      form.querySelectorAll('.form-unit').forEach(function (button) { button.setAttribute('aria-pressed', String(clean(button.textContent) === unit)); });
    }
    function limitsFor(owner, key, previousUnit) {
      const ranges = owner.__csCustomLimitsIn || (owner.__csCustomLimitsIn = {});
      if (!ranges[key]) {
        const inputs = formsFor(owner).flatMap(function (form) { return Array.from(form.querySelectorAll(LEGACY_FIELDS[key])); });
        const primary = inputs.find(function (input) { return !input.classList.contains('clone'); }) || inputs[0];
        // Girls inputs retain adult min/max in the old markup, but their main
        // placeholder is the intended range. Use that same range for both views.
        const placeholder = primary && clean(primary.getAttribute('placeholder')).match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
        ranges[key] = ['min', 'max'].map(function (name, index) {
          const value = placeholder ? placeholder[index + 1] : primary && primary.getAttribute(name);
          return value != null && clean(value) && Number.isFinite(Number(value)) ? Number(value) / (previousUnit === 'CM' ? 2.54 : 1) : null;
        });
      }
      return ranges[key];
    }
    function syncValues(owner, values, previousUnit, unit) {
      const changed = [];
      formsFor(owner).forEach(function (form) {
        Object.keys(LEGACY_FIELDS).forEach(function (key) {
          if (!Object.prototype.hasOwnProperty.call(values, key)) return;
          form.querySelectorAll(LEGACY_FIELDS[key]).forEach(function (input) {
            if (input.value !== values[key]) { input.value = values[key]; changed.push(input); }
            input.step = '0.01';
            const limits = limitsFor(owner, key, previousUnit).map(function (value) { return value == null ? null : Math.round(value * (unit === 'CM' ? 2.54 : 1) * 100) / 100; });
            ['min', 'max'].forEach(function (name, index) { if (limits[index] != null) input.setAttribute(name, limits[index]); });
            if (limits.every(function (value) { return value != null; })) input.placeholder = limits.join(' - ');
          });
        });
        setUnit(form, unit);
      });
      return changed;
    }
    doc.addEventListener('input', function (event) {
      const input = event.target;
      const form = input.closest && input.closest('.ced-custom-form');
      if (!form) return;
      const key = Object.keys(LEGACY_FIELDS).find(function (name) { return Array.from(form.querySelectorAll(LEGACY_FIELDS[name])).includes(input); });
      if (!key) return;
      const owner = ownerFor(form);
      const state = stateFor(owner, form);
      const values = convertMeasurements({ [key]: input.value }, state.unit, state.unit, state);
      syncValues(owner, values, state.unit, state.unit);
    }, false); // Let each field's existing inline oninput sanitize first.
    doc.addEventListener('click', function (event) {
      const control = event.target.closest && event.target.closest('.form-unit,.unit-switch');
      const form = control && control.closest('.ced-custom-form');
      if (!form) return;
      const owner = ownerFor(form);
      const state = stateFor(owner, form);
      const next = control.classList.contains('unit-switch') ? (state.unit === 'CM' ? 'IN' : 'CM') : clean(control.textContent);
      if (next !== 'IN' && next !== 'CM') return;
      // Legacy templates attach several global jQuery handlers to these controls.
      // Own this custom-only event once, before those handlers can toggle twice.
      event.preventDefault(); event.stopImmediatePropagation();
      const values = {};
      Object.keys(LEGACY_FIELDS).forEach(function (key) { const input = form.querySelector(LEGACY_FIELDS[key]); if (input) values[key] = input.value; });
      const converted = convertMeasurements(values, state.unit, next, state);
      const changed = syncValues(owner, converted, state.unit, next);
      state.unit = next;
      const EventType = doc.defaultView && doc.defaultView.Event || scope.Event;
      if (EventType) changed.forEach(function (input) { input.dispatchEvent(new EventType('change', { bubbles: true })); });
    }, true);
  }
  function range(field, unit) { return unit === 'CM' ? [Math.round(field.min * 254) / 100, Math.round(field.max * 254) / 100] : [field.min, field.max]; }
  function validate(values, unit) {
    const data = values || {};
    const chosenUnit = unit === 'CM' ? 'CM' : 'IN';
    const errors = {};
    const properties = { Size: 'Custom size', Unit: chosenUnit === 'CM' ? 'Centimeter' : 'Inch' };
    FIELDS.forEach(function (field) {
      const value = clean(data[field.key]);
      const limits = range(field, chosenUnit);
      if (!value && !field.optional) errors[field.key] = field.label + ' is required.';
      else if (value && (!Number.isFinite(Number(value)) || Number(value) < limits[0] || Number(value) > limits[1])) errors[field.key] = field.label + ' must be between ' + limits[0] + ' and ' + limits[1] + '.';
      else if (value) properties[field.property] = value;
    });
    if (!clean(data.heels) || data.heels === 'Please select') errors.heels = 'HEIGHT OF HEELS is required.';
    else properties['HEIGHT OF HEELS'] = clean(data.heels);
    if (data.consent !== true) errors.consent = 'Please accept the Custom Sizing terms.';
    return { valid: Object.keys(errors).length === 0, errors, properties };
  }
  function clearProperties(existing, standardSize) {
    const result = {};
    Object.keys(existing || {}).forEach(function (key) { if (!MEASUREMENT_KEYS.has(key.toUpperCase())) result[key] = existing[key]; });
    result.Size = standardSize;
    return result;
  }
  function replaceProperties(existing, values, unit) {
    const validation = validate(values, unit);
    if (!validation.valid) return null;
    const unrelated = {};
    Object.keys(existing || {}).forEach(function (key) {
      if (!MEASUREMENT_KEYS.has(key.toUpperCase())) unrelated[key] = existing[key];
    });
    return Object.assign({}, validation.properties, unrelated);
  }
  function fromProperties(properties) {
    const source = properties || {};
    const values = {};
    FIELDS.forEach(function (field) { values[field.key] = clean(source[field.property] || (field.key === 'hollow' ? source['HOLLOW TO FLOOR'] : '')); });
    values.heels = clean(source['HEIGHT OF HEELS']);
    values.consent = /^custom size$/i.test(clean(source.Size));
    return { values, unit: /^(cm|centimeter)$/i.test(clean(source.Unit)) ? 'CM' : 'IN' };
  }
  function element(tag, className, copy) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (copy) node.textContent = copy;
    return node;
  }
  function mount(host, options) {
    const settings = options || {};
    let unit = normalizeUnit(settings.unit);
    const values = Object.assign({}, settings.values || {});
    const conversionState = settings.conversionState || {};
    let activeGuide = '';
    host.replaceChildren();
    host.classList.add('cs-custom-size');
    const heading = element('div', 'cs-custom-size__heading');
    heading.append(element('strong', '', 'Size Measurement'));
    const switcher = element('div', 'cs-custom-size__units');
    const grid = element('div', 'cs-custom-size__grid');
    const inputs = {};
    const rows = {};
    function emit() { if (typeof settings.onChange === 'function') settings.onChange(Object.assign({}, values), unit); }
    function showGuide(key) {
      if (activeGuide === key) return;
      Object.values(rows).forEach(function (row) { const old = row.querySelector('.cs-custom-size__guide'); if (old) old.remove(); });
      activeGuide = key;
      const field = FIELDS.find(function (candidate) { return candidate.key === key; });
      if (!field) return;
      const guide = element('div', 'cs-custom-size__guide');
      guide.append(element('p', '', field.tip));
      if (field.image) {
        const preview = element(field.video ? 'button' : 'div', 'cs-custom-size__preview');
        if (field.video) preview.type = 'button';
        const image = element('img'); image.src = FILES + field.image; image.alt = field.label + ' measurement guide';
        preview.append(image);
        if (field.video) {
          preview.setAttribute('aria-label', 'Play ' + field.label + ' measurement video');
          preview.addEventListener('click', function () {
            if (document.querySelector('.cs-custom-size__video-overlay')) return;
            const overlay = element('div', 'cs-custom-size__video-overlay');
            const player = element('div', 'cs-custom-size__video-player');
            const close = element('button', 'cs-custom-size__video-close', '×'); close.type = 'button'; close.setAttribute('aria-label', 'Close video');
            const video = element('video'); video.controls = true; video.autoplay = true; video.playsInline = true; video.src = VIDEOS + field.video;
            function dismiss() { video.pause(); overlay.remove(); }
            close.addEventListener('click', dismiss);
            overlay.addEventListener('keydown', function (event) { if (event.key === 'Escape') { dismiss(); preview.focus(); } });
            overlay.addEventListener('click', function (event) { if (event.target === overlay) dismiss(); });
            player.append(video, close); overlay.append(player); document.body.append(overlay); close.focus();
          });
        }
        guide.append(preview);
      }
      rows[key].append(guide);
    }
    function updateUnit(next) {
      if (next === unit) return;
      Object.assign(values, convertMeasurements(values, unit, next, conversionState));
      FIELDS.forEach(function (field) { inputs[field.key].value = clean(values[field.key]); });
      unit = next;
      FIELDS.forEach(function (field) { const limits = range(field, unit); inputs[field.key].placeholder = limits[0] + ' - ' + limits[1]; rows[field.key].querySelector('.cs-custom-size__unit').textContent = '(' + unit + ')'; });
      switcher.querySelectorAll('button').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.unit === unit)); });
      emit();
    }
    ['IN', 'CM'].forEach(function (name) { const button = element('button', '', name); button.type = 'button'; button.dataset.unit = name; button.setAttribute('aria-pressed', String(name === unit)); button.addEventListener('click', function () { updateUnit(name); }); switcher.append(button); });
    heading.append(switcher); host.append(heading);
    FIELDS.forEach(function (field) {
      const row = element('div', 'cs-custom-size__field');
      const label = element('label', '', field.label + (field.optional ? ' (Optional)' : ''));
      const input = element('input'); input.type = 'number'; input.step = '0.01'; input.inputMode = 'decimal';
      const limits = range(field, unit); input.placeholder = limits[0] + ' - ' + limits[1]; input.value = clean(values[field.key]);
      input.dataset.csField = field.key;
      input.addEventListener('focus', function () { showGuide(field.key); });
      input.addEventListener('input', function () { values[field.key] = input.value; emit(); });
      label.append(input); row.append(label, element('span', 'cs-custom-size__unit', '(' + unit + ')'));
      grid.append(row); rows[field.key] = row; inputs[field.key] = input;
    });
    const heelRow = element('div', 'cs-custom-size__field');
    const heelLabel = element('label', '', 'HEIGHT OF HEELS');
    const heelSelect = element('select'); heelSelect.dataset.csField = 'heels';
    HEELS.forEach(function (choice) { const option = element('option', '', choice); option.value = choice; heelSelect.append(option); });
    heelSelect.value = clean(values.heels) || 'Please select';
    heelSelect.addEventListener('change', function () { values.heels = heelSelect.value; emit(); });
    heelLabel.append(heelSelect); heelRow.append(heelLabel); grid.append(heelRow); inputs.heels = heelSelect; host.append(grid);
    const images = element('div', 'cs-custom-size__images');
    const butt = element('figure'); const buttImage = element('img'); buttImage.src = FILES + 'butt.jpg'; buttImage.alt = 'Hip and butt measurement comparison'; butt.append(buttImage, element('figcaption', '', "IT'S NECESSARY IF BUTT IS BIGGER THAN HIP"));
    const figure = element('img'); figure.src = FILES + 'en.jpg?v=1716774934'; figure.alt = 'Custom size measurement guide'; images.append(figure, butt); host.append(images);
    const consent = element('label', 'cs-custom-size__consent');
    const checkbox = element('input'); checkbox.type = 'checkbox'; checkbox.checked = values.consent === true; checkbox.dataset.csField = 'consent'; checkbox.addEventListener('change', function () { values.consent = checkbox.checked; emit(); });
    const consentCopy = element('span', '', 'I confirm that I understand and agree to the Custom Sizing terms and conditions:');
    const terms = element('ul', 'cs-custom-size__terms');
    [
      'Custom sizing is final sale and non-returnable for any reason.',
      'The measurements provided are my own and are not the measurements of a standard size.',
      'The dress will be made exactly to the measurements provided; ChicSew will not add any room for comfort.',
      'My dress may require additional alterations at my expense.',
      'My dress may not appear exactly as it does online.',
      'If you have a big belly, please provide its measurement and the length from shoulder over nipple to belly in the note too.'
    ].forEach(function (copy) { terms.append(element('li', '', copy)); });
    consentCopy.append(terms);
    consent.append(checkbox, consentCopy);
    host.append(consent); inputs.consent = checkbox;
    function showErrors() {
      const result = validate(values, unit);
      host.querySelectorAll('.cs-custom-size__error').forEach(function (error) { error.remove(); });
      Object.keys(result.errors).forEach(function (key) { const input = inputs[key]; if (!input) return; input.setAttribute('aria-invalid', 'true'); input.parentElement.append(element('small', 'cs-custom-size__error', result.errors[key])); });
      const first = Object.keys(result.errors)[0]; if (first && inputs[first]) inputs[first].focus();
      return result;
    }
    return { read: function () { return { values: Object.assign({}, values), unit }; }, showErrors, destroy: function () { host.replaceChildren(); } };
  }
  const api = { FIELDS, validate, replaceProperties, clearProperties, fromProperties, mount, convertMeasurements, bindLegacyForms };
  scope.ChicSewCustomSizing = api;
  bindLegacyForms(scope.document);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
